// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {StageModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

export interface StageFormFieldsType {
  stageId?: string;
  name?: string;
  organizationId: number | string;
  playbookTemplateId?: number | null;
  projectStatus?: string;
  description?: string;
  color?: string;
}

export type StageFormType = Form<{stageForm: StageFormFieldsType}>;

const _new = ({
  organizationId,
  projectStatus,
}: {
  organizationId: number | string;
  projectStatus: string;
}): StageFormFieldsType => {
  return {
    organizationId,
    name: '',
    playbookTemplateId: null,
    projectStatus,
    description: '',
    color: '',
  };
};

const edit = withFragment(
  (stage: StageModel): StageFormFieldsType => ({
    stageId: stage.id,
    organizationId: stage.organizationId,
    name: stage.name,
    playbookTemplateId: stage.playbookTemplateId,
    projectStatus: stage.projectStatus,
    description: stage.description,
    color: stage.color,
  }),
  gql`
    fragment StageForm_edit on Stage {
      id
      organizationId
      name
      playbookTemplateId
      projectStatus
      description
      color
    }
  `,
);

const toForm = ({
  stageId,
  organizationId,
  name,
  playbookTemplateId,
  projectStatus,
  description,
  color,
}: StageFormFieldsType): StageFormFieldsType => ({
  stageId,
  organizationId,
  name,
  playbookTemplateId,
  projectStatus,
  description,
  color,
});

const toMutation = ({
  stageId,
  organizationId,
  name,
  playbookTemplateId,
  projectStatus,
  description,
  color,
}: StageFormFieldsType): StageFormFieldsType => ({
  stageId,
  organizationId,
  name,
  playbookTemplateId,
  projectStatus,
  description,
  color,
});

const StageForm = {
  toForm,
  toMutation,
  new: _new,
  edit,
};

export default StageForm;
